import { ColorMode } from '@chakra-ui/color-mode/dist/color-mode-types';
import { AggregatedView } from 'src/components/viewers/SheetsViewerV2/hooks/useSheetsAggregatedView';

export type ThemeOptions = { colorMode: ColorMode };

export function setTheme(
  aggregatedView: AggregatedView,
  options: ThemeOptions
) {
  aggregatedView.viewer.navigation.setReverseZoomDirection(true);

  // Get the sheets viewer container
  const sheetsViewerContainer = document.getElementById('sheets-viewer-v2');

  switch (options.colorMode) {
    case 'dark':
      // Don't use Forge Viewer's dark theme to avoid interference with CSS filter
      // aggregatedView.viewer.setTheme('dark-theme');
      // Use #e3e5ef (light color) so that after invert(1) hue-rotate(180deg) it becomes dark
      aggregatedView.viewer.setBackgroundColor(227, 229, 239, 227, 229, 239);
      // Apply CSS filter for dark mode - same as V1 system
      if (sheetsViewerContainer) {
        sheetsViewerContainer.style.filter = 'invert(1) hue-rotate(180deg)';
      }
      break;
    case 'light':
      aggregatedView.viewer.setTheme('light-theme');
      aggregatedView.viewer.setBackgroundColor(247, 250, 252, 247, 250, 252);
      // Remove CSS filter for light mode
      if (sheetsViewerContainer) {
        sheetsViewerContainer.style.filter = '';
      }
      break;
  }
}
